import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListMethodPaymentResponseDTO, EnclosureByCityResponseDTO, BusByTicketResponseDTO } from 'src/app/data/dto/EnclosuresDTO';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnclosuresService {
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  listMethodPayment(): Observable<ListMethodPaymentResponseDTO> {
    const endpoint = environment.method_payment_endpoint;
    const httpOptions = {
      headers: this.headers,
    };
    return this.http.get<ListMethodPaymentResponseDTO>(
      `${environment.base_url}/${endpoint}`,
      httpOptions
    );
  }

  // Upload example file (v1) using multipart/form-data
  uploadExampleFile(file: File): Observable<any> {
    const endpoint = environment.file_example_endpoint;
    const formData = new FormData();
    formData.append('file', file);
    // Do not set Content-Type so the browser sets the boundary
    return this.http.post(
      `${environment.url_base}/${endpoint}`,
      formData
    );
  }

  // Build download URL from a file path or file name returned by backend
  buildFileExampleDownloadUrl(filePathOrName: string): string {
    if (!filePathOrName) return '';
    const onlyName = this.getFileNameFromPath(filePathOrName);
    return `${environment.url_base}/${environment.file_example_download_endpoint}?file=${encodeURIComponent(onlyName)}`;
  }

  // Extract file name from 'assets/...' or plain names
  private getFileNameFromPath(path: string): string {
    if (!path) return '';
    const parts = path.split('/');
    return parts[parts.length - 1];
  }

  // Same upload but with progress events
  uploadExampleFileWithProgress(file: File): Observable<HttpEvent<any>> {
    const endpoint = environment.file_example_endpoint;
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(
      `${environment.url_base}/${endpoint}`,
      formData,
      { reportProgress: true, observe: 'events' }
    );
  }

  getEnclosuresByCity(localityId: any): Observable<EnclosureByCityResponseDTO> {
    const idParam = localityId === 0 || localityId === '0' ? '' : localityId;
    return this.http.get<EnclosureByCityResponseDTO>(
      `${environment.url_base}/recinto/by-city?localityId=${idParam}`,
      { headers: this.headers }
    );
  }

  getBusesByTicket(idTicket: number): Observable<BusByTicketResponseDTO> {
    return this.http.get<BusByTicketResponseDTO>(
      `${environment.base_url}/enclosure/busesByTicket/${idTicket}`,
      { headers: this.headers }
    );
  }

  getEnclosureByAdminAndRecinto(idAdmin: any, idRecinto: any): Observable<any> {
    return this.http.get<any>(
      `${environment.base_url}/enclosure/onlyEnclosureByAdmin/${idAdmin}/${idRecinto}`,
      { headers: this.headers }
    );
  }
}
